import { LocaleD } from "@prisma/client"
import { CategoryTranslationD, CategoryWithSubcategoryD } from "app/data/categories/category.types"
import { CategoryVM, CategoryWithSubcategoriesVM } from "app/models/category"
import { LocalizedEntity, TranslationSelector } from "app/models/common"
import { array, nonEmptyArray } from "fp-ts"
import { pipe } from "fp-ts/function"

const mapToCategoryWithSubcategoriesVM =
  (translationSelector: TranslationSelector, locale: LocaleD) =>
  (category: CategoryWithSubcategoryD): CategoryWithSubcategoriesVM => {
    const subcategories = category.subcategories
      ? pipe(
          category.subcategories,
          array.map(mapToCategoryWithSubcategoriesVM(translationSelector, locale))
        )
      : []

    return {
      id: category.id,
      locale,
      name: pipe(category.translations, translationSelector, (translation) => translation.name),
      namePath: pipe(
        category.translations,
        translationSelector,
        (translation) => translation.namePath
      ),
      slugPath: pipe(
        category.translations,
        translationSelector,
        (translation) => translation.slugPath
      ),
      subcategories,
    }
  }

export type CategoryMap = LocalizedEntity<nonEmptyArray.NonEmptyArray<CategoryWithSubcategoriesVM>>

export const toCategoryVM = ({ name, namePath, slugPath }: CategoryTranslationD): CategoryVM => ({
  name,
  namePath,
  slugPath,
})

export const toCategoryMap = (
  categories: nonEmptyArray.NonEmptyArray<CategoryWithSubcategoryD>
): CategoryMap => ({
  en_ca: pipe(
    categories,
    nonEmptyArray.map(mapToCategoryWithSubcategoriesVM(nonEmptyArray.head, LocaleD.en_ca))
  ),
  fr_ca: pipe(
    categories,
    nonEmptyArray.map(mapToCategoryWithSubcategoriesVM(nonEmptyArray.last, LocaleD.fr_ca))
  ),
})
